// Tarjouksen vaihepolku. Lähetys ja tulos ovat tilaajan tietoja eivätkä muuta vaihetta.
// Uusi tarjous alkaa tarjouspyyntönä (REQUEST), josta se siirretään laskentaan tai merkitään "Ei tarjota".
// Vaihesiirrot tarkistaa backend (OfferStatus.canChangeTo); Tilattu (ORDERED) tulee projektin perustamisesta, ja
// samalla saman tarjottavan projektin muut tarjoukset merkitään toteutetuiksi toiselle tilaajalle (ORDERED_ELSEWHERE).

export const STATUSES = ['REQUEST', 'CALCULATION', 'REVIEW', 'READY', 'ORDERED', 'NOT_ORDERED', 'DECLINED', 'ORDERED_ELSEWHERE'];
export const ACTIVE_STATUSES = ['REQUEST', 'CALCULATION', 'REVIEW', 'READY'];
export const FINAL_STATUSES = ['ORDERED', 'NOT_ORDERED', 'DECLINED', 'ORDERED_ELSEWHERE'];

// Siirtymät, joille syy on pakollinen
export const REASON_REQUIRED = {
  'REVIEW>CALCULATION': true,
  'READY>NOT_ORDERED': true,
  'CALCULATION>DECLINED': true,
  'REVIEW>DECLINED': true,
  'READY>DECLINED': true,
};

// Samat tallennusarvot kuin AddOrEditItemDialog.unitOptions (m2, m3), jotta nimikkeen ja rivin yksikkö on vertailtava.
export const UNITS = ['kpl', 'm', 'kg', 'l', 'm2', 'm3', 'erä', 'h', 'tn', 'vrk'];

// Esteet siirtymälle CALCULATION → REVIEW (näytetään UI:ssa v-alertissa).
export function blockers(q) {
  const out = [];
  if (!q.name || !q.name.trim()) out.push('name_missing');
  if (!q.sites || q.sites.length === 0) out.push('no_sites');
  const rowCount = (q.sites || []).reduce((n, s) => n + (s.rows || []).filter(r => !r.conditional).length, 0);
  if (rowCount === 0) out.push('no_rows');
  return out;
}

// Varoitukset (eivät estä): rivit ilman määrää
export function warnings(q) {
  const out = [];
  const rows = (q.sites || []).flatMap(s => (s.rows || []).filter(r => !r.conditional));
  if (rows.some(r => r.quantity == null || r.quantity === 0)) out.push('rows_without_quantity');
  return out;
}
